// extracted by mini-css-extract-plugin
export default {"table":"DepartmentDetailsTable-module__table__r81bj","link":"DepartmentDetailsTable-module__link__-Of8c"};